module.exports = __webpack_public_path__ + "img/home-setting-active-1.dce87d59.png";